import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-16 md:py-24 px-5 bg-[#FAF5EE] text-[#2D2D2D]" data-id="element-143">
      <div className="max-w-2xl mx-auto" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-145">
          <h2 className="font-serif text-3xl md:text-5xl text-[#5C1A2B] mb-8 leading-tight" data-id="element-146">
            Aceptas sobras y las llamas amor.
          </h2>

          <div className="space-y-6 text-base md:text-lg font-light leading-relaxed text-[#4A4A4A]" data-id="element-147">
            <p data-id="element-148">
              Te conformas con un "hola" perdido a medianoche porque te da
              esperanza. Pero la realidad es cruel:
            </p>

            <p className="text-[#C86B5E] font-medium italic font-serif text-xl md:text-2xl leading-snug" data-id="element-149">
              Tienes los deberes de una esposa, la entrega de una amante, pero
              la importancia de una desconocida.
            </p>

            <p data-id="element-150">
              Él sabe cuánto te duele su silencio.{' '}
              <strong className="font-medium text-[#2D2D2D]" data-id="element-151">
                No le importa lo suficiente como para romperlo.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}